import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";
import GameAdmin from "./lazy";

export default {
    component: GameAdmin,
    renderSeo: ({ dispatch }, allMessage, lang) => {
        return seo({ title: "Game admin", allMessage, lang });
    },
} satisfies IRoute;